import { createAction } from '@reduxjs/toolkit';
import { SnackState } from './snackTypes';

export const showSnackAction = createAction<SnackState>('SNACK/SHOW');
export const hideSnackAction = createAction<void>('SNACK/HIDE');
